var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { debounce } from "lodash-es";
import { Inject, Prop, Ref, Component, Vue } from 'vue-property-decorator';
import classNames from "../../../../lib/utils/classNames";
import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";
let FileUploader = class FileUploader extends Vue {
  constructor() {
    super(...arguments);
    this.inputFocused = false;
    this.isUploading = false;
    this.uploadProgress = 0; // ~ 100
  }
  handleUploadBtnClick() {
    const {
      uploadInput
    } = this;
    uploadInput.value = '';
    uploadInput.onchange = () => {
      var _uploadInput$files;
      const file = (_uploadInput$files = uploadInput.files) === null || _uploadInput$files === void 0 ? void 0 : _uploadInput$files[0];
      if (!file) return;
      this.startUpload(file);
    };
    uploadInput.click();
  }
  startUpload(file) {
    if (!this.actualAllowUpload) return;
    this.isUploading = true;
    this.uploadProgress = 0;
    this.uc.config.fileUploadHandler({
      file,
      onProgress: (current, total) => {
        this.uploadProgress = Math.floor(current * 100 / total);
      }
    }).then(url => {
      this.textInput.value = url;
      this.$emit('change', url);
    }, error => {
      console.error('[UICore] 文件上传失败', error);
      this.uc.ui.message({
        content: `上传失败：${error}`,
        duration: 8000,
        type: 'error'
      });
    }).then(() => {
      this.isUploading = false;
    });
  }
  handlePasteEvent(ev) {
    var _ev$clipboardData;
    const file = (_ev$clipboardData = ev.clipboardData) === null || _ev$clipboardData === void 0 || (_ev$clipboardData = _ev$clipboardData.files) === null || _ev$clipboardData === void 0 ? void 0 : _ev$clipboardData[0];
    if (file) this.startUpload(file);
  }
  handleDropEvent(ev) {
    var _ev$dataTransfer;
    const file = (_ev$dataTransfer = ev.dataTransfer) === null || _ev$dataTransfer === void 0 || (_ev$dataTransfer = _ev$dataTransfer.files) === null || _ev$dataTransfer === void 0 ? void 0 : _ev$dataTransfer[0];
    if (file) {
      this.startUpload(file);
      ev.preventDefault();
    }
  }
  get actualAllowUpload() {
    if (this.readonly || this.isUploading) return false;
    return true;
  }
  created() {
    this.debouncedHandleInput = debounce(() => {
      this.$emit('change', this.textInput.value);
    }, 250);
  }
  beforeDestroy() {
    this.debouncedHandleInput.cancel();
  }
  mounted() {
    this.$watch(() => [this.inputFocused, this.value], ([inputFocused, url], old) => {
      if (inputFocused) return;
      const [wasFocused] = old || [];
      if (wasFocused) this.debouncedHandleInput.flush();else this.textInput.value = url;
    }, {
      immediate: true
    });
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": classNames('uc-inputbox w-fileUploader', this.isUploading && 'isUploading'),
      "on": {
        "drop": this.handleDropEvent
      }
    }, [h("input", {
      "attrs": {
        "type": "file"
      },
      "style": "display: none",
      "ref": "uploadInput"
    }), h("input", {
      "attrs": {
        "type": "text",
        "autocomplete": "off",
        "placeholder": this.placeholder,
        "readonly": !this.allowInput || !this.actualAllowUpload
      },
      "ref": "textInput",
      "on": {
        "focus": () => void (this.inputFocused = true),
        "blur": () => void (this.inputFocused = false),
        "input": this.debouncedHandleInput,
        "paste": this.handlePasteEvent
      },
      "class": "w-fileUploader-input"
    }), h("button", {
      "attrs": {
        "type": "button",
        "disabled": !this.actualAllowUpload
      },
      "class": "w-fileUploader-uploadBtn",
      "on": {
        "click": this.handleUploadBtnClick
      }
    }, [this.isUploading ? [h("i", {
      "class": "fa fa-spin fa-spinner",
      "attrs": {
        "aria-hidden": "true"
      }
    }), ` ${this.uploadProgress}%`] : [h("i", {
      "class": "fa fa-upload",
      "attrs": {
        "aria-hidden": "true"
      }
    }), ' 上传']]), this.isUploading && h("div", {
      "class": "w-fileUploader-progressBar",
      "style": `width:${this.uploadProgress}%`
    })]);
  }
};
__decorate([Prop({
  type: String
})], FileUploader.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], FileUploader.prototype, "readonly", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], FileUploader.prototype, "required", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FileUploader.prototype, "allowInput", void 0);
__decorate([Prop({
  type: String,
  default: '输入URL，或点击右侧按钮上传'
})], FileUploader.prototype, "placeholder", void 0);
__decorate([Ref()], FileUploader.prototype, "uploadInput", void 0);
__decorate([Ref()], FileUploader.prototype, "textInput", void 0);
__decorate([Inject({
  from: INJECT_UICORE_BUS
})], FileUploader.prototype, "uc", void 0);
FileUploader = __decorate([Component({})], FileUploader);
export default FileUploader;
//# sourceMappingURL=index.js.map
